import { Copy, Landmark } from "lucide-react";
import { toast } from "sonner";
import { useMe } from "@/context/MeContext";
import { eur } from "@/lib/api";

const Row = ({ label, value, testid }) => (
  <div className="flex items-center justify-between gap-3 border-b border-white/5 py-2 last:border-0">
    <span className="text-xs uppercase tracking-wider text-slate-400">{label}</span>
    <button
      type="button"
      data-testid={testid}
      onClick={() => navigator.clipboard?.writeText(String(value)).then(() => toast.success("Copiato"))}
      className="flex items-center gap-2 text-right font-mono text-sm text-white hover:text-amber-300"
    >
      {value} <Copy className="h-3.5 w-3.5 opacity-60" />
    </button>
  </div>
);

export function BankTransferInfo({ order }) {
  const { config } = useMe();
  if (!config) return null;
  if (order.amount_due <= 0)
    return <p data-testid="paid-with-points-note" className="rounded-xl bg-emerald-500/10 p-3 text-sm text-emerald-300">Ordine pagato interamente con i punti: nessun bonifico da effettuare.</p>;
  return (
    <div data-testid={`bank-info-${order.id}`} className="rounded-2xl border border-white/10 bg-white/[0.03] p-4">
      <p className="mb-2 flex items-center gap-2 font-semibold text-white"><Landmark className="h-4 w-4 text-amber-400" /> Bonifico istantaneo</p>
      <Row label="Intestatario" value={config.holder} testid="bank-holder" />
      <Row label="IBAN" value={config.iban} testid="bank-iban" />
      {config.bank && <Row label="Banca" value={config.bank} testid="bank-name" />}
      <Row label="Importo" value={eur(order.amount_due)} testid="bank-amount" />
      <Row label="Causale" value={order.causale} testid="bank-causale" />
      <p className="mt-2 text-xs text-slate-500">L'ordine viene confermato quando l'Admin riceve il bonifico.</p>
    </div>
  );
}
